<header class="bg-primary">
  <nav class='navbar navbar-expand-md navbar-toggleable-md navbar-dark border-bottom box-shadow mb-3'>
    <div class="container">
      <div>
        <a class="navbar-brand text-white py-0" style="font-size: 1em" [routerLink]='[""]'>SCOHR&nbsp;<small class="text-secondary">AB 1433</small></a>
        <p style="font-size:10px" class="text-secondary my-0 py-0" *ngIf="username != ''">
          Welcome, <span class="text-secondary">{{username}}</span>
        </p>
      </div>

      <button role="button" class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse"
              aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>

      <ng-container *ngIf="isHelpDeskSession">
        <button (click)="returnToHelpDesk()" class="btn btn-danger">Return To Help Desk</button>
      </ng-container>

      <div class="navbar-collapse collapse d-md-inline-flex flex-md-row-reverse" [ngClass]='{"show": isExpanded}'>
        <ul [ngSwitch]="isLoggedIn" class="navbar-nav">

          <li *ngSwitchCase="true" class="nav-item" [routerLinkActive]='["link-active"]' ngbDropdown>
            <a class="nav-link text-white" id="dropdownBasic0" ngbDropdownToggle>Main</a>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic0" class="bg-primary">
              <a [hidden]="checkNotLocked()" class="dropdown-item text-white" [routerLink]='["/admin/authrequest"]'>Authorization</a>
              <a [hidden]="!checkNotLocked()" class="dropdown-item text-white" [routerLink]='["/admin/main"]'>Home</a>
              <a class="dropdown-item text-white" [routerLink]='["/home/overview"]'>Overview</a>
              <a class="dropdown-item text-white" [routerLink]='["/home/sjcoecodestack"]'>SJCOE/CodeStack</a>
              <a class="dropdown-item text-white" [routerLink]='["/home/accessibility"]'>Accessibility</a>
              <a class="dropdown-item text-white" [routerLink]='["/home/datacapture"]'>Data Capture</a>
              <a class="dropdown-item text-white" [routerLink]='["/home/reporting"]'>Reporting</a>
            </div>
          </li>

          <li *ngIf="checkAuth('AccessDataInput')" class="nav-item" [routerLinkActive]='["link-active"]' ngbDropdown>
            <a class="nav-link text-white" id="dropdownBasic1" ngbDropdownToggle>Data Input</a>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="bg-primary">
              <a class="dropdown-item text-white" [routerLink]='["/admin/data/input"]'>Data Input Form</a>
              <a class="dropdown-item text-white" [routerLink]='["/admin/data/fixUpload"]'>Fix Upload Errors</a>
              <a class="dropdown-item text-white" [routerLink]='["/admin/data/upload"]'>Upload Data</a>
            </div>
          </li>

          <li *ngIf="checkAuth('ManageDistricts')" class="nav-item" [routerLinkActive]='["link-active"]'>
            <a class="nav-link text-white" [routerLink]='["/admin/districts"]'>Districts</a>
          </li>

          <li *ngIf="checkAuth('AccessForms')" class="nav-item" [routerLinkActive]='["link-active"]' ngbDropdown>
            <a class="nav-link text-white" id="dropdownBasic2" ngbDropdownToggle>Forms</a>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic2" class="bg-primary">
              <a class="dropdown-item text-white" [routerLink]='["/admin/forms/assessment"]'>Assessment Forms</a>
              <a class="dropdown-item text-white" [routerLink]='["/admin/forms/waiver"]'>Waiver Forms</a>
              <a class="dropdown-item text-white" [routerLink]='["/admin/forms/demographic"]'>Demographic Only</a>
              <a class="dropdown-item text-white" [routerLink]='["/admin/forms/fixUpload"]'>Fix Upload Errors</a>
              <a class="dropdown-item text-white" [routerLink]='["/admin/forms/upload"]'>Upload Forms</a>
            </div>
          </li>

          <li *ngIf="checkAuth('ManageAnnouncements')" class="nav-item" [routerLinkActive]='["link-active"]'>
            <a class="nav-link text-white" [routerLink]='["/admin/announcement"]'>Announcements</a>
          </li>

          <li *ngIf="checkNotLocked()" class="nav-item" [routerLinkActive]='["link-active"]' ngbDropdown>
            <a class="nav-link text-white" id="dropdownBasic3" ngbDropdownToggle>Reports</a>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic3" class="bg-primary ">
              <a *ngIf="checkAuth('AccessStateReport')" class="dropdown-item text-white" [routerLink]='["/admin/reports/state"]'>State Report</a>
              <a *ngIf="checkAuth('AccessSchoolReport')" class="dropdown-item text-white" [routerLink]='["/admin/reports/school"]'>School Report</a>
              <a *ngIf="checkAuth('AccessSummaryReport')" class="dropdown-item text-white" [routerLink]='["/admin/reports/summary"]'>Summary Report</a>
              <a *ngIf="checkAuth('AccessComparisonReport')" class="dropdown-item text-white" [routerLink]='["/admin/reports/comparison"]'>Comparison Report</a>
            </div>
          </li>

          <li *ngIf="checkAuth('ManageUsers')" class="nav-item" [routerLinkActive]='["link-active"]'>
            <a class="nav-link text-white" [routerLink]='["/admin/users"]'>Users</a>
          </li>

          <li *ngIf="checkAuth('ManageSchools')" class="nav-item" [routerLinkActive]='["link-active"]'>
            <a class="nav-link text-white" [routerLink]='["/admin/schools"]'>Schools</a>
          </li>

          <li *ngIf="checkAuth('ListServe')" class="nav-item" [routerLinkActive]='["link-active"]'>
            <a class="nav-link text-white" [routerLink]='["/admin/list-serve"]'>List Serve</a>
          </li>

          <li *ngSwitchCase="true" class="nav-item" [routerLinkActive]='["link-active"]' ngbDropdown>
            <a class="nav-link text-white" id="dropdownBasic5" ngbDropdownToggle>Help</a>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic5" class="bg-primary">
              <a class="dropdown-item text-white" href="/assets/SCOHR_User_Manual_2023.pdf" target="_blank">Download User Manual</a>
              <a class="dropdown-item text-white" [routerLink]="['/admin/faq-menu/']">Help Center</a>
              <!--<hr class="dropdown-divider" />
              <a class="dropdown-item text-white" [routerLink]="['/admin/faq/', 'account']">Create/Edit User Accounts</a>
              <a class="dropdown-item text-white" [routerLink]='["/admin/faq/login"]'>Login Username/Password</a>
              <a class="dropdown-item text-white" [routerLink]='["/admin/faq/forms"]'>Forms and Data Inputs</a>
              <a class="dropdown-item text-white" [routerLink]='["/admin/faq/kinder"]'>Oral Health Requirements</a>-->
            </div>
          </li>

          <li *ngSwitchCase="true" class="nav-item" [routerLinkActive]='["link-active"]'>
            <a class="nav-link text-white" (click)="logout()">Logout</a>
          </li>

          <!-- Public Menu Items -->
          <li *ngSwitchCase="false" class="nav-item">
            <a class="nav-link text-white" [routerLink]='[""]'>Overview</a>
          </li>
          <li *ngSwitchCase="false" class="nav-item" [routerLinkActive]='["link-active"]'>
            <a class="nav-link text-white" [routerLink]='["/home/sjcoecodestack"]'>SJCOE/CodeStack</a>
          </li>
          <li *ngSwitchCase="false" class="nav-item" [routerLinkActive]='["link-active"]'>
            <a class="nav-link text-white" [routerLink]='["/home/accessibility"]'>Accessibility</a>
          </li>
          <li *ngSwitchCase="false" class="nav-item" [routerLinkActive]='["link-active"]'>
            <a class="nav-link text-white" [routerLink]='["/home/datacapture"]'>Data Capture</a>
          </li>
          <li *ngSwitchCase="false" class="nav-item" [routerLinkActive]='["link-active"]'>
            <a class="nav-link text-white" [routerLink]='["/home/reporting"]'>Reporting</a>
          </li>
          <li *ngSwitchCase="false" class="nav-item" [routerLinkActive]='["link-active"]'>
            <a class="nav-link text-white" [routerLink]='["/signup"]'>Sign Up</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
